import { useEmailTesting } from "../hooks/useEmailTesting";

function EmailPreview({ token }) {
  const {
    catalogLoading,
    groupedCatalog,
    emailType,
    setEmailType,
    lang,
    setLang,
    recipientName,
    setRecipientName,
    testEmail,
    setTestEmail,
    preview,
    previewLoading,
    previewError,
    sendLoading,
    sendMessage,
    handleSendTest,
    selectedTemplate,
  } = useEmailTesting(token);

  return (
    <>
      <header className="admin-dash-header">
        <div>
          <h1 className="admin-dash-title">E-mail teszt</h1>
          <p className="admin-dash-subtitle">
            Sablon előnézet és teszt küldés egy címre.
          </p>
        </div>
      </header>

      <div className="admin-email-layout">
        <aside className="admin-email-sidebar">
          <h2 className="admin-email-panel-title">Sablonok</h2>
          {catalogLoading ? (
            <p className="admin-dash-empty">Betöltés…</p>
          ) : (
            Object.entries(groupedCatalog).map(([category, items]) => (
              <div key={category} className="admin-email-catalog-group">
                <p className="admin-email-catalog-label">{category}</p>
                <div className="admin-email-catalog-list">
                  {items.map((item) => (
                    <button
                      key={item.id}
                      type="button"
                      className={`admin-email-catalog-item${emailType === item.id ? " is-active" : ""}`}
                      onClick={() => setEmailType(item.id)}
                    >
                      <span>{item.label}</span>
                      {!item.sendSupported && (
                        <span className="admin-email-badge">Csak előnézet</span>
                      )}
                    </button>
                  ))}
                </div>
              </div>
            ))
          )}

          <div className="admin-email-form">
            <label className="admin-email-field">
              <span>Nyelv</span>
              <select value={lang} onChange={(e) => setLang(e.target.value)}>
                <option value="hu">Magyar</option>
                <option value="en">English</option>
              </select>
            </label>

            <label className="admin-email-field">
              <span>Címzett neve (opcionális)</span>
              <input
                type="text"
                value={recipientName}
                onChange={(e) => setRecipientName(e.target.value)}
                placeholder="pl. Anna"
              />
            </label>

            <label className="admin-email-field">
              <span>Teszt e-mail cím</span>
              <input
                type="email"
                value={testEmail}
                onChange={(e) => setTestEmail(e.target.value)}
                placeholder="teszt@example.com"
              />
            </label>

            <button
              type="button"
              className="admin-dash-btn admin-dash-btn-primary admin-email-send-btn"
              onClick={handleSendTest}
              disabled={sendLoading || !emailType || !selectedTemplate?.sendSupported}
            >
              {sendLoading ? "Küldés…" : "Teszt e-mail küldése"}
            </button>

            {sendMessage && (
              <p className="admin-email-message" role="status">
                {sendMessage}
              </p>
            )}
          </div>
        </aside>

        <section className="admin-email-preview">
          <div className="admin-email-preview-head">
            <h2 className="admin-email-panel-title">Előnézet</h2>
            {preview.subject && (
              <p className="admin-email-subject">
                <strong>Tárgy:</strong> {preview.subject}
              </p>
            )}
          </div>

          {previewError && (
            <p className="admin-email-error" role="alert">
              {previewError}
            </p>
          )}

          <div className="admin-email-preview-frame-wrap">
            {previewLoading && (
              <p className="admin-email-preview-loading">Előnézet frissítése…</p>
            )}
            {preview.html ? (
              <iframe
                title="E-mail előnézet"
                className="admin-email-preview-frame"
                srcDoc={preview.html}
                sandbox=""
              />
            ) : (
              !previewLoading && (
                <p className="admin-dash-empty">Válassz sablont az előnézethez.</p>
              )
            )}
          </div>
        </section>
      </div>
    </>
  );
}

export default EmailPreview;
